import { useState, useEffect } from "react";
import axios from "axios";
import { useLang } from "@/context/LanguageContext";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { API, ax, errorText } from "./common";

const BASE = `${API}/admin/settings`;

// Platform administrator only: switches that change how the whole system behaves.
export default function SettingsTab({ showMsg }) {
  const { t } = useLang();
  const [settings, setSettings] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(BASE, ax).then(({ data }) => setSettings(data))
      .catch(e => showMsg("error", errorText(e, t("adm.error"))));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async (changes) => {
    setBusy(true);
    try {
      const { data } = await axios.put(BASE, changes, ax);
      setSettings(data);
      showMsg("success", t("adm.settings.saved"));
    } catch (e) { showMsg("error", errorText(e, t("adm.error"))); }
    setBusy(false);
  };

  if (!settings) return null;

  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <Label htmlFor="over-stock" className="font-semibold text-slate-900 text-sm">{t("adm.settings.over_stock")}</Label>
          <p className="text-sm text-slate-600">{t(settings.pallet_over_stock ? "adm.settings.over_stock_on" : "adm.settings.over_stock_off")}</p>
        </div>
        <Switch id="over-stock" checked={settings.pallet_over_stock} disabled={busy} onCheckedChange={on => save({ pallet_over_stock: on })}
          className="data-[state=checked]:bg-green-600 data-[state=unchecked]:bg-red-500" />
      </div>
    </div>
  );
}
